import { useState } from 'react'
import { useAppStore } from '../store/useAppStore'
import Header from '../components/ui/Header'
import Button from '../components/ui/Button'
import Card from '../components/ui/Card'
import { FUEL_LABELS, FUEL_COLORS } from '../utils/constants'
import toast from 'react-hot-toast'

export default function FuelScreen() {
  // ✅ Sélecteurs atomiques — cohérent avec PhotoScreen et AnnotationCanvas
  const inspection       = useAppStore(s => s.inspection)
  const updateInspection = useAppStore(s => s.updateInspection)
  const setStep          = useAppStore(s => s.setStep)

  // ✅ Conversion automatique : si l'ancienne valeur est <= 8 (échelle fractionnée), on multiplie par 12.5 pour passer en %
  const getInitialFuel = () => {
    const val = inspection.fuel ?? 50
    return val <= 8 ? Math.round(val * 12.5) : val
  }

  const [fuel,    setLocalFuel]    = useState(getInitialFuel())
  const [mileage, setLocalMileage] = useState(inspection.mileage ?? '')

  const validate = () => {
    if (!mileage || isNaN(mileage) || Number(mileage) < 0) {
      return toast.error('Veuillez indiquer le kilométrage')
    }
    // ✅ updateInspection existe dans le store — une seule action, deux champs
    updateInspection({ fuel, mileage: Number(mileage) })
    setStep('security')
  }

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <Header title="Carburant & Kilométrage" showBack backStep="photos" />
      <div className="flex-1 p-6 max-w-2xl mx-auto w-full flex flex-col gap-6">

        {/* Fuel gauge */}
        <Card className="p-6">
          <h2 className="text-lg font-bold text-gray-800 mb-5">Niveau de carburant</h2>
          <div className="flex flex-col items-center gap-4">

            {/* Visual gauge (11 paliers de 10%) */}
            <div className="flex items-end gap-1 h-24">
              {FUEL_LABELS.map((label, i) => {
                const threshold = i * 10
                const isActive = fuel >= threshold
                return (
                  <button
                    key={i}
                    onClick={() => setLocalFuel(threshold)}
                    className={`flex-1 rounded-t-lg transition-all min-w-8 ${isActive ? 'opacity-100' : 'opacity-25'}`}
                    style={{
                      height: `${30 + i * 8}px`,
                      backgroundColor: FUEL_COLORS[i],
                      border: (fuel >= threshold && fuel < threshold + 10) || (i === 10 && fuel === 100)
                        ? '3px solid #111' 
                        : '2px solid transparent',
                    }}
                  />
                )
              })}
            </div>

            {/* Labels E / 50% / F */}
            <div className="flex gap-1 w-full">
              {FUEL_LABELS.map((label, i) => (
                <div key={i} className="flex-1 text-center">
                  <span className={`text-[10px] sm:text-xs font-medium ${(fuel >= i * 10 && fuel < i * 10 + 10) || (i === 10 && fuel === 100) ? 'text-gray-800 font-bold' : 'text-gray-400'}`}>
                    {i === 0 ? 'E' : i === 10 ? 'F' : i === 5 ? '50%' : ''}
                  </span>
                </div>
              ))}
            </div>

            {/* Valeur courante avec précision au % */}
            <div className="text-center mt-2">
              <span className="text-4xl font-black" style={{ color: FUEL_COLORS[Math.floor(fuel / 10)] }}>
                {fuel}%
              </span>
            </div>

            {/* Slider avec pas de 1% */}
            <input
              type="range" min={0} max={100} step={1} value={fuel}
              onChange={e => setLocalFuel(Number(e.target.value))}
              className="w-full h-3 bg-gray-200 rounded-lg appearance-none cursor-pointer accent-blue-600"
            />
          </div>
        </Card>

        {/* Mileage */}
        <Card className="p-6">
          <h2 className="text-lg font-bold text-gray-800 mb-4">Kilométrage</h2>
          <div className="flex items-center gap-3">
            <input
              type="number"
              value={mileage}
              onChange={e => setLocalMileage(e.target.value)}
              placeholder="Ex : 45 230"
              className="flex-1 border-2 border-gray-200 rounded-xl px-4 py-4 text-2xl font-bold text-center focus:border-blue-500 focus:outline-none"
              min={0}
              inputMode="numeric"
            />
            <span className="text-xl font-semibold text-gray-500">km</span>
          </div>
        </Card>

        <Button onClick={validate} size="xl" className="w-full mt-auto">
          Continuer vers les signatures →
        </Button>

      </div>
    </div>
  )
}